import { gql } from '@apollo/client/core'

import {
  SERVER_ERROR,
  UNAUTHENTICATED_ERROR,
  UNAUTHORIZED_ERROR
} from '@base/api/fragments/errors'

export const GET_BOOKING_TEE_TIME_QUERY = gql`
  ${UNAUTHENTICATED_ERROR}
  ${UNAUTHORIZED_ERROR}
  ${SERVER_ERROR}

  query getBookingTeeTime($id: String!) {
    GetTeeTime(teeTimeId: $id) {
      ... on GetTeeTimeOutput {
        teeTime {
          id
          course {
            ... on GetCourseOutput {
              course {
                id
                courseName
                slug
                club {
                  ... on GetClubOutput {
                    club {
                      id
                      clubName
                      slug
                      addressLine1
                      addressLine2
                    }
                  }
                  ...UnauthenticatedError
                  ...UnauthorizedError
                  ...ServerError
                }
              }
            }
            ...UnauthenticatedError
            ...UnauthorizedError
            ...ServerError
          }
          time
          availability
          spotsRemaining
          admissions {
            id
            fee9
            fee18
            admissionType {
              ... on GetAdmissionTypeOutput {
                admissionType {
                  id
                  name
                  position
                }
              }
              ...UnauthenticatedError
              ...UnauthorizedError
              ...ServerError
            }
          }
        }
      }
      ...UnauthenticatedError
      ...UnauthorizedError
      ...ServerError
    }
  }
`
